import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex bg-white/70 backdrop-blur-lg border border-blue-50 rounded-lg shadow-xl shadow-purple-700/30" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "hidden sm:inline-block px-4 py-2 text-orange-800 text-sm font-medium rounded-r-lg cursor-not-allowed",
  disabled: ""
}, " Select a Wallet ", -1)

import { useModal, useWorkspace } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { open } = useModal();
const { clusterName } = useWorkspace();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "inline-block px-4 py-2 text-orange-800 text-sm font-medium rounded-lg sm:rounded-r-none hover:bg-white/60",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(open)('modal-update-cluster'))),
      textContent: _toDisplayString(_unref(clusterName))
    }, null, 8, _hoisted_2),
    _hoisted_3
  ]))
}
}

})